import axios, { AxiosRequestConfig } from "axios";

import getErrorDetails from "./helpers/getErrorDetails";

/**
 * @deprecated Do not use it in the new code base
 * @todo It should be migrated to RTK Query
 */
export async function getFailingNotifications(
  options: AxiosRequestConfig
): Promise<any> {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: "/notifications/failures",
    });
    const { data = {} } = response;

    return data;
  } catch (error) {
    throw getErrorDetails(error);
  }
}
